<template>
    <div>
        <van-nav-bar title="专区推荐" left-arrow @click-left="closePage" style="z-index: 10000;"></van-nav-bar>
        <div class="xytj" v-if="showList && xyList.length > 0">
            <div :class="{xy_item:true,today:item.showFlag == 1}" v-for="(item,i) in xyList" :key="i" ref="xyitem">
                <div :class="{xy_date:true}" :style="{'z-index': i+50}">{{judgeDate(item.date)}}</div>
                <div class="xy_content">
                    <service-item :arr="item.list" :odd="item.list.length%2!=0" :even="item.list.length%2 == 0" />
                </div>
            </div>
        </div>
        <div class="empty" v-else-if="showList && xyList.length == 0">
            <img class="empty_img" src="../../assets/games/qs.png" alt="">
            <div class="word">{{ text }}</div>
        </div>
    </div>
</template>

<script>
    import api from '../Api'
    import $ from 'jquery'
    export default {
        mixins: [api],
        data() {
            return {
                xyList: [],
                showList: false,
                text: '主人，来的太早啦，敬请期待~'
            }
        },
        computed: {
            //服务器时间
            currentServeTime() {
                return new Date(new Date().valueOf() - this.$store.state.differTime);
            },
        },
        mounted() {
            this.getGameNewestList()
        },
        methods: {
            judgeDate(time) {
                var artTime = time.replace(/-/g, '/')
                var str = ''
                if (new Date(artTime).getDate() == new Date(this.currentServeTime).getDate()) {
                    str = '今日'
                } else if (new Date(artTime).getDate() == new Date(this.currentServeTime).getDate() + 1) {
                    str = '明日'
                } else if (new Date(artTime).getDate() == new Date(this.currentServeTime).getDate() - 1) {
                    str = '昨日'
                } else {
                    str = time.slice(0, 16)
                }
                return str
            },
            getGameNewestList() {
                this.$Ajax('game/game-newest-list').then(rs => {
                    if (rs.code == 200) {
                        this.xyList = rs.data
                        this.$nextTick(() => {
                            var arr = this.$refs.xyitem
                            var offsetTop = 0
                            for (var i = 0; i < arr.length; i++) {
                                if ($(arr[i]).hasClass('today')) {
                                    offsetTop = arr[i].offsetTop
                                }
                            }
                            if (this.screenWidth > 556) {
                                offsetTop -= 80
                            }
                            document.body.scrollTop = document.documentElement.scrollTop = offsetTop
                        })
                    }else {
                        this.xyList = []
                        if(rs.msg != '暂无数据') {
                            this.text = rs.msg
                        }
                    }
                }).finally(() => {
                    setTimeout(() => {
                        this.showList = true
                    },200)
                })
            },
        },
    }
</script>

<style lang="less" scoped>
    .xytj {
        margin-top: 2.5rem;
        .xy_item {
            margin-bottom: .25rem;

            .xy_date {
                color: #000;
                font-size: .7rem;
                padding-left: 1rem;
                padding-top: .5rem;
                padding-bottom: .5rem;
                position: sticky;
                top: 50px;
                background-color: #f2f2f2;
                overflow: hidden;

                &.xy_date2 {
                    top: 3.3rem;
                }

                &::after {
                    content: '';
                    position: absolute;
                    right: 0.75rem;
                    top: 1rem;
                    width: 56%;
                    height: .025rem;
                    background-color: #9E9E9E;
                }
            }

            .xy_content {
                padding: 0 .75rem;
            }
        }
    }
    .empty {
        margin-top: 2.5rem;
        padding-top: 5rem;
        display: flex;
        flex-direction: column;
        align-items: center;
        .empty_img {
            width: 8.5rem;
            height: 8.25rem;
        }
        .word {
            font-size: .7rem;
            color: #000;
            margin-top: 1.5rem;
        }
    }

</style>
